import axios from 'axios';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

function getHeaders() {
  const token = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

async function call(method, path, params) {
  try {
    const response = await axios({ method, url: `${ADMIN_URL}${path}`, params, headers: getHeaders() });
    return { status: 'ok', data: response.data.data, meta: response.data.meta };
  } catch (error) {
    const body = error.response?.data ?? {};
    return { status: 'error', code: body.code ?? body.message ?? 'UNKNOWN', httpCode: error.response?.status };
  }
}

/** Actuarial model (pawer-backend spec 095): snapshots and margins, aggregates only. */
export default class ActuarialService {
  static listSnapshots() {
    return call('get', '/actuarial/snapshots');
  }

  static compute() {
    return call('post', '/actuarial/snapshots/compute');
  }

  static diff(id, countryIso) {
    return call('get', `/actuarial/snapshots/${id}/diff`, { countryIso, against: 'published' });
  }

  static publish(id) {
    return call('post', `/actuarial/snapshots/${id}/publish`);
  }

  static planMargins(countryIso, snapshot) {
    return call('get', '/actuarial/plan-margins', { countryIso, snapshot });
  }

  static planMarginHistory(countryIso, plan, tierFrom) {
    return call('get', '/actuarial/plan-margins/history', { countryIso, plan, tierFrom });
  }

  static partnerOffers(countryIso, snapshot) {
    return call('get', '/actuarial/partner-offers', { countryIso, snapshot });
  }

  static services(countryIso, snapshot) {
    return call('get', '/actuarial/services', { countryIso, snapshot });
  }
}
